import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AccountConversationsBackend {
  private readonly accountConversationsApiUrl = '/api/account/conversations';
  private readonly accountV2ConversationsApiUrl =
    '/api/v2/account/conversations';
  v1 = {
    postSubmessages: (conversationId: string, message: string) =>
      this.http.post(
        `${this.accountConversationsApiUrl}/${conversationId}/submessages`,
        { message },
      ),
  };
  v2 = {
    post: (
      message: string,
      participants: { account: string; role: string }[],
      is_match_intro: boolean,
      origin: string,
    ) =>
      this.http.post(this.accountV2ConversationsApiUrl, {
        ...(origin && { origin }),
        is_match_intro,
        message,
        participants,
      }),
  };

  constructor(private http: HttpClient) {}
}
